module.exports = __webpack_public_path__ + "img/am06.2467950b.jpg";